import script from "./pestview.vue?vue&type=script&setup=true&lang=ts"
export * from "./pestview.vue?vue&type=script&setup=true&lang=ts"

import "./pestview.vue?vue&type=style&index=0&id=035b70a4&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-035b70a4"]])

export default __exports__